import * as Api from '@ViewModels';
import * as React from 'react';
import {
	SocialMediaImagesPreviewAlert,
	SocialMediaImagesPreviewImages,
	SocialMediaImagesPreviewRadioButtons,
} from '../../../web/components/socialMedia/SocialMediaImagesPreviewModal/presentation';

interface IProps {
	className?: string;
	images?: Api.IFileAttachment[];
	initialImageUrl?: string;
	showOverlayLogo?: boolean;
	logoUrl?: string;
	hideWhiteBackground?: boolean;
}

export function ComplianceSocialMediaImagesPreviewModal({
	images,
	initialImageUrl,
	showOverlayLogo,
	logoUrl,
	hideWhiteBackground,
}: IProps) {
	const [currentImageIndex, setCurrentImageIndex] = React.useState(
		initialImageUrl && images ? images.findIndex(i => i.url === initialImageUrl) : 0
	);
	const onImageIndexChange = (index: number) => () => {
		setCurrentImageIndex(index);
	};
	return (
		<div>
			<div>
				{showOverlayLogo ? <SocialMediaImagesPreviewAlert /> : null}
				<SocialMediaImagesPreviewImages
					images={images}
					currentImageIndex={currentImageIndex}
					showOverlayLogo={showOverlayLogo}
					url={logoUrl}
					onImageIndexChange={onImageIndexChange}
					hideWhiteBackground={hideWhiteBackground}
				/>
				{images?.length > 1 ? (
					<SocialMediaImagesPreviewRadioButtons
						key='images-radio-buttons'
						currentImageIndex={currentImageIndex}
						images={images}
						onImageIndexChange={onImageIndexChange}
					/>
				) : null}
			</div>
		</div>
	);
}
